import { Content } from '../../types';

export const baNaHillsParkContent: Content = {
  title: 'פארק Ba Na Hills - עולם קסום בגובה 1,500 מטר',
  imageUrl: '/images/vietnam/ba-na-hills-park/ba-na-hills-park-wide.jpeg',
  introduction:
    'פארק Ba Na Hills הינו פארק שעשועים ונופש ייחודי השוכן בגבעות בא נא, בגובה של כ-1,500 מטר מעל פני הים, במרחק של כ-30 דקות נסיעה מערבה לעיר דה נאנג. הפארק מציע חוויית בילוי מגוונת עם נוף מרהיב, רכבל ארוך ומהפנט, גנים מטופחים, אטרקציות ייחודיות ואווירה אירופית קסומה.',
  sections: [
    {
      title: 'רכבל בא נא הילס',
      content:
        'ההגעה לפארק נעשית באמצעות חמישה מסלולי רכבל, כאשר הארוך שבהם נמשך כ-25 דקות ומהווה אחת מהנסיעות הארוכות בעולם ברכבל. בדרך ובהנחה שזכיתם ליום בהיר, תוכלו ליהנות מנופים מדהימים של יערות עבותים, מפלים ונוף פנורמי מרהיב.',
      type: 'text',
    },
    {
      title: 'גשר הידיים - Golden Bridge',
      content:
        'האטרקציה המרכזית והמפורסמת ביותר בפארק הינה גשר הידיים (Golden Bridge), גשר מוזהב באורך של כ-150 מטר הנתמך על ידי זוג ידיים ענקיות הנראות כאילו הן מגיחות מתוך ההר. הגשר מספק תצפית עוצרת נשימה על ההרים והיערות מסביב, במיוחד בשעות הבוקר כשערפילים עוטפים את הנוף.',
      type: 'text',
    },
    {
      title: 'כפר צרפתי - French Village',
      content:
        'אזור זה בפארק משחזר את האדריכלות והאווירה של כפר צרפתי עתיק, כולל מבנים קלאסיים, כנסיות, כיכרות עם מזרקות, סמטאות אבן צרות, מסעדות בסגנון אירופי ובתי קפה המזכירים את פריז. המקום מציע גם מופעים חיים של אמנים ורקדנים המוסיפים לאווירה הקסומה.',
      type: 'text',
    },
    {
      title: 'פארק השעשועים Fantasy Park',
      content:
        'זהו פארק שעשועים מקורה המשתרע על שלוש קומות ומציע עשרות מתקנים לכל הגילאים, כולל רכבות הרים, סימולטורים, רכבת שדים, משחקי וידאו, מתקני טיפוס, קרוסלות ואפילו מוזיאון שעווה שבו ניתן למצוא דמויות מוכרות מסרטים והיסטוריה עולמית.',
      type: 'text',
    },
    {
      title: 'מזחלות הרים Alpine Coaster',
      content:
        'אחת האטרקציות המהנות ביותר היא מזחלות ההרים שניתן לשלוט בהן באופן עצמאי. המסלול מתפתל בין ההרים והיערות ומעניק חוויית אקסטרים מהנה לכל המשפחה.',
      type: 'text',
    },
    {
      title: 'גני פרחים ופסלים',
      content:
        "פארק הגנים Le Jardin d'Amour כולל תשעה גנים מעוצבים בסגנונות שונים עם פרחים צבעוניים, פסלים אומנותיים ומבוכים ירוקים. הגנים מציעים רקע מושלם לצילום תמונות יפות.",
      type: 'text',
    },
    {
      title: 'מקדשים ונקודות תצפית',
      content:
        'בפארק ניתן למצוא גם מקדשים בודהיסטיים מרשימים, כולל פסלים גדולים של בודהה ונקודות תצפית מרהיבות המשקיפות על דה נאנג והאזור ההררי שמסביב.',
      type: 'text',
    },
    {
      title: 'מופעים ופעילויות נוספות',
      content:
        'במהלך היום מתקיימים בפארק מופעים חיים של אמני רחוב, מופעי קסמים, הופעות מוזיקליות ותהלוכות צבעוניות. בחלק מהאירועים ניתן להשתתף וליהנות מאינטראקציה עם השחקנים.',
      type: 'text',
    },
    {
      title: 'מסעדות ומתחמי אוכל',
      content:
        'בפארק מבחר רחב של מסעדות ומזנונים המציעים מאכלים מקומיים ובינלאומיים, כולל אוכל וייטנאמי מסורתי, מטבח צרפתי, פיצריות ודוכני חטיפים.',
      type: 'text',
    },
    {
      title: 'טיפים להגעה ולתכנון הביקור',
      content: [
        'שעות פתיחה: הפארק פתוח כל יום בין השעות 08:00-17:00.',
        'תחבורה: הדרך הנוחה ביותר להגעה לפארק הינה באמצעות מונית או רכב פרטי. במידה ומגיעים במונית, מומלץ לסכם עם הנהג על המתנה עד לסיום הביקור.',
        'לבוש: בשל הגובה, הטמפרטורה בפארק קרירה יותר מאשר בעיר, לכן מומלץ להביא עליונית.',
        'כרטיסים: מומלץ לרכוש כרטיסים מראש, במיוחד בעונות התיירות העמוסות.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בשורה התחתונה, פארק Ba Na Hills מציע שילוב ייחודי של טבע, אדריכלות, תרבות ואטרקציות מודרניות, מה שהופך אותו לאחד מאתרי החובה בביקור בוייטנאם. זהו מקום שמספק חוויה בלתי נשכחת למבקרים בכל הגילים!',
      type: 'text',
    },
  ],
};
